import { createTenant, CreateTenant } from '@infuse/api/iam/tenant';
import { UiNotificationType } from '@infuse/ui/domain';
import { useNotify } from '@infuse/ui/services';
import { getAxiosErrorMessage } from '@infuse/utils';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';

export const useCreateTenant = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();
  const { t } = useI18n({ useScope: 'global' });

  const mutation = useMutation<unknown, unknown, CreateTenant>({
    mutationFn: async (tenant: CreateTenant) => {
      try {
        await createTenant({}, tenant);
        notify({
          title: t('iam.tenants.header.create_tenant'),
          message: t('iam.tenants.notify.create_tenant_success')
        });
      } catch (e) {
        notify({
          type: UiNotificationType.ERROR,
          title: t('iam.tenants.header.create_tenant'),
          message: getAxiosErrorMessage(e, t('iam.tenants.notify.create_tenant_failed'))
        });
        throw e;
      }
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['tenants'] });
    }
  });

  return {
    ...mutation
  };
};
